import { render, staticRenderFns } from "./ContractMain.vue?vue&type=template&id=4c943887"
import script from "./ContractMain.vue?vue&type=script&lang=js"
export * from "./ContractMain.vue?vue&type=script&lang=js"
import style0 from "./ContractMain.vue?vue&type=style&index=0&id=4c943887&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
